import Vue from 'vue';
import Vuex from 'vuex';

import authStore from '@/store/modules/authStore.js';
import language from "@/store/modules/language";

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth: authStore,
        language: language,
    },
    plugins: [
        createPersistedState({
            key: 'auth',
            paths: ['auth'],
            storage: window.sessionStorage,
        }),
    ],
});

export default store;